export default "__VITE_ASSET__6d19a62f__"